<template>
  <div class="l-m-charts">
    <div class="wrapper" v-if="!isShowSubPage">
      <div class="header">图表管理</div>
      <div class="body" :style="getHeightStyle()">
        <div class="item-list">
          <div
            class="little-item"
            @click="handleOpenSubPage(value)"
            v-for="(value, key, index) in catergory"
            :key="index"
          >
            <div class="little-item-img">
              <img class="item-img" :src="value.OverViewImg" alt="" />
            </div>
            <div class="little-item-title">{{ value.CateName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper" v-if="isShowSubPage">
      <div class="header" @click="isShowSubPage = !isShowSubPage">
        <i class="back-arrow el-icon-arrow-left"></i>
        <span>{{ selectedCatergory.CateName }}</span>
      </div>
      <div class="body" :style="getHeightStyle()">
        <div
          class="item"
          v-for="(item, index) in selectedCatergory.Children"
          :key="index"
          ondragstart="return false;"
        >
          <div class="item-img" @mousedown="handleAddComponent(item, $event)">
            <img class="img" :src="item.componentOverViewImg" alt="" />
            <img
              class="img-drag"
              v-show="readyAddComponentName === item.componentName"
              :style="moveItemStyle"
              :src="item.componentOverViewImg"
            />
          </div>
          <div class="item-name">{{ item.componentTitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { nanoid } from 'nanoid';
export default {
  name: 'LMCharts',
  props: {
    ProjectInfo: Object,
  },
  data() {
    return {
      isShowSubPage: false,
      catergory: {},
      selectedCatergory: {},
      readyAddComponentName: '',
      moveItemStyle: {
        position: 'fixed',
        zIndex: 99999,
        opacity: 0.4,
        left: '0px',
        top: '0px',
      },
      ChartsSetUse: [],
    };
  },
  created() {
    this.getChartsCatergory();
  },
  mounted() {
    this.cycleIdFunction();
    console.log(this.ProjectInfoList, 'ProjectInfoList');
  },
  computed: {
    // newChartsSetUse () {
    //   return JSON.parse(JSON.stringify(this.ChartsSetUse));
    // },
    ProjectInfoList() {
      return this.$store.state.ProjectInfo.CurrentScene;
    },
  },
  watch: {
    ChartsSetUse(mmmm) {},
    // newChartsSetUse (newVal,) {
    //   console.log(newVal, '  newVal');
    // },
  },
  methods: {
    getHeightStyle() {
      return {
        height: this.$store.state.ClientViewSize.height - 80 + 'px',
      };
    },
    getChartsCatergory() {
      const rawCharts = this.$store.state.ChartsList;
      let catergory = {};
      let cateList = [];
      rawCharts.forEach(item => {
        cateList.push(item.componentName.replace(/\d/g, ''));
      });
      cateList = [...new Set(cateList)];
      console.log(cateList, 'this.$store.state.ChartsList;');
      let cateListIndex = cateList.findIndex(val => val === 'OthersCharts');
      let cateListLastIndex = cateList.length - 1;
      [cateList[cateListIndex], cateList[cateListLastIndex]] = [
        cateList[cateListLastIndex],
        cateList[cateListIndex],
      ];
      cateList.forEach(key => {
        // console.log(key, 'charts key');
        let CateName = '';
        switch (key) {
          case 'LineCharts':
            CateName = '折线图';
            break;
          case 'BarCharts':
            CateName = '柱状图';
            break;
          case 'PieCharts':
            CateName = '饼状图';
            break;
          case 'RadarCharts':
            CateName = '雷达图';
            break;
          case 'GaugeCharts':
            CateName = '仪表图';
            break;
          case 'PictorialBarCharts':
            CateName = '象形图';
            break;
          case 'EarthCharts':
            CateName = '地图';
            break;
          case 'TableCharts':
            CateName = '表格';
            break;
          case 'OthersCharts':
            CateName = '其他';
            break;
          case 'TextCharts':
            CateName = '文本';
            break;
          case 'ThreeCharts':
            CateName = '3D图';
            break;
          default:
            CateName = '';
        }
        catergory[key] = {
          CateName,
          OverViewImg: `./img/charts/${key}.png`,
          Children: [],
        };
        rawCharts.forEach(item => {
          if (item.componentName.replace(/\d/g, '') === key) {
            catergory[key].Children.push(item);
          }
        });
      });
      this.catergory = catergory;
    },
    handleOpenSubPage(data) {
      this.selectedCatergory = data;
      this.isShowSubPage = true;
    },
    // 判断 是否为 组合组件
    cycleIdFunction() {
      let ChartsSet = this.ProjectInfoList.Charts.map(chart => {
        if (chart.componentName === 'Others10Charts') {
          return {
            id: chart.id,
            x: [chart.style.left, chart.style.left + chart.style.width],
            y: [chart.style.top, chart.style.top + chart.style.height],
          };
        } else {
          return null;
        }
      });
      // 去掉 null 值
      let target = ChartsSet.filter(current => {
        return current !== null;
      });
      this.ChartsSetUse = target;
    },
    handleAddComponent(data, even) {
      this.cycleIdFunction();
      this.readyAddComponentName = data.componentName;
      const startY = even.clientY;
      const startX = even.clientX;
      this.moveItemStyle.top = startY - 50 + 'px';
      this.moveItemStyle.left = startX + -50 + 'px';
      const startTop = parseInt(this.moveItemStyle.top);
      const startLeft = parseInt(this.moveItemStyle.left);
      const addEndPos = {};
      let move = moveEvent => {
        const currX = moveEvent.clientX;
        const currY = moveEvent.clientY;
        this.moveItemStyle.top = currY - startY + startTop + 'px';
        this.moveItemStyle.left = currX - startX + startLeft + 'px';
        addEndPos.left = currX - 320;
        addEndPos.top = currY - 130;
      };
      this.moveAddEndPos = addEndPos;
      const up = e => {
        const protX = addEndPos.left;
        const protY = addEndPos.top;
        if (this.ChartsSetUse.length != 0) {
          let charfilter = this.ChartsSetUse.filter(item => {
            if (protX > item?.x[0] && protX < item?.x[1] && protY > item?.y[0] && protY < item?.y[1]) {
              return item;
            }
          });
          if (charfilter.length == 0) {
            setTimeout(() => {
              this.addCharts(data, addEndPos, 'add_Charts');
            }, 100);
          } else {
            this.ChartsSetUse.map(comid => {
              charfilter.map(char => {
                if (comid.id === char.id) {
                  setTimeout(() => {
                    this.addCharts(data, addEndPos, 'back_add_charts', comid.id);
                  }, 100);
                }
              });
            });
          }
        } else {
          // 当 length 为 0 时
          setTimeout(() => {
            this.addCharts(data, addEndPos, 'add_Charts');
          }, 100);
        }
        this.readyAddComponentName = '';
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    },
    //add_Charts
    addCharts(data, addEndPos, name, id) {
      let Config = this.$_.cloneDeep(data);
      if (Config.style) {
        addEndPos.left = addEndPos.left - Config.style.width / 2;
        addEndPos.top = addEndPos.top - Config.style.height / 2;
        for (let key in addEndPos) {
          Config.style[key] = addEndPos[key];
        }
      }
      Config.id = nanoid();
      let CongInfo = { Config, id };
      this.$store.commit(name, CongInfo);
    },
  },
};
</script>
<style lang="scss" scoped>
.l-m-charts {
  width: 240px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .wrapper {
    width: 100%;
    height: 100%;
  }
  .header {
    width: 100%;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    color: $font-color-base;
    user-select: none;
    background-color: #2c2e3f;
    position: relative;

    .back-arrow {
      position: absolute;
      left: 5%;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
    }
  }
  .body {
    box-sizing: border-box;
    width: 100%;

    overflow: hidden;
    overflow-y: scroll;

    padding: 20px 0px 50px 0px;
    &::-webkit-scrollbar-thumb {
      background: #191e29 !important;
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar {
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar-track {
      background: #43455800;
    }
    .item-list {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      .little-item {
        width: 110px;
        height: 104px;
        border-radius: 5px;
        background: #272836;
        flex-shrink: 0;
        margin-left: 8px;
        margin-bottom: 15px;
        cursor: pointer;
        position: relative;
        &:hover .little-item-img .item-img {
          border: 1px solid #335ae9;
        }
        .little-item-img {
          user-select: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          .item-img {
            user-select: none;
            width: 100%;
            height: 100%;
            border-radius: 5px;
            box-sizing: border-box;
            overflow: hidden;
            border: 1px solid rgba(0, 0, 0, 0);
            transition: all 0.1s linear;
          }
        }
        .little-item-title {
          user-select: none;
          color: $font-color-base;
          text-align: center;

          width: 100%;
          font-size: 14px;
          position: absolute;
          bottom: 5px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .item {
      margin: 0 auto;
      // background-color: rosybrown;
      width: 100%;
      height: 160px;
      // margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .item-img {
        cursor: pointer;
        width: 202px;
        height: 128px;
        box-sizing: border-box;
        background-color: rgba(20, 20, 27, 0.733);
        border: 1px solid rgba(0, 0, 0, 0);
        transition: border 0.2s;
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        &:hover {
          border: 1px solid rgb(70, 59, 226);
        }
        .img {
          overflow: hidden;
          position: absolute;
          top: 0;
          width: 202px;
          height: 128px;
        }
        .img-drag {
          overflow: hidden;
          position: absolute;
          top: 0;
          width: 100px;
          height: 60px;
        }
      }
      .item-name {
        user-select: none;
        // width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: $font-color-base;
      }
    }
  }
}
</style>
